import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import {
  ProductsBiocatchEnum,
  StepBiocatchEnum,
} from 'src/app/shared/enums/biocatchContext.enum';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { OccupationModel } from 'src/app/shared/models/occupation.model';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { IncomesService } from 'src/app/shared/services/incomes/incomes.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { OpEnum } from '../../../shared/enums/op.enum';
import { DocumentModel } from '../../../shared/models/document.model';
import { IProductsModel } from '../../../shared/models/products.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { IdentificationService } from '../../../shared/services/identification/identification.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { ERROR_LIB } from 'src/app/shared/constants/abre-cuentas.constants';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-update-data',
  templateUrl: './update-data.component.html',
  styleUrls: ['./update-data.component.scss'],
})

/**
 * Clase del componente de introducción al escaneo del documento
 *
 * *Document introduction component class*
 */
export class UpdateDataComponent implements OnInit {
  documentInfo: DocumentModel;
  options: any = [];
  product_type: string;
  product_code: string;
  pcoStatusCode: string;
  occupationSelected: OccupationModel;
  mandatoryUpdate: boolean;
  data: any;
  mobilePhoneOffice: any;
  pcoAmountValidation: boolean;
  productSelected: IProductsModel;
  inferredIncomes: any;
  is_loading_complete: boolean;
  livingResidence: any;
  closeLoading = false;
  loanNormalization = false;
  /**
   * Constructor of the component.
   *
   * @param {HeaderService}     headerService     Injectable headerService service.
   * @param {NavigationService} navigationService Injectable navigationService service.
   * @function headerService.show() Hides header
   */
  constructor(
    public copyService: CopyService,
    private taggingServices: TaggingService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private validationHelperService: ValidationHelperService,
    private captureService: CaptureService,
    private configurationService: ConfigurationService,
    private requestService: RequestService,
    private parametersService: ParametersService,
    private identificationService: IdentificationService,
    private bitacoraService: BitacoraService,
    private bioCatchService: BioCatchService,
    private productLoaderService: ProductLoaderService,
    private firmlyApprovedService: FirmlyApprovedService,
    private incomesService: IncomesService,
    private helperService: HelpersService,
    private adjustEvent: AdjustEvent,
    private channelCommunicatorService: ChannelCommunicatorService,
    private daliService: DaliService,
  ) {
    this.headerService.show(false, false, false);
  }

  /**
   * Función de Angular ejecutada una vez el componente sea cargado
   *
   * *Angular function that is run when the component is loaded*
   */
  ngOnInit() {
    this.callIncomes();
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.options = this.abreCuentasService.getBusinessConfig(OpEnum.CITY_LIST);
    this.occupationSelected = this.abreCuentasService.getOccupationSelected();
    this.productSelected = this.abreCuentasService.getproductSelected();
    this.data = this.abreCuentasService.getAbreCuentasModel();
    this.inferredIncomes = this.abreCuentasService.getinfoInferredIncomes();
    if (this.productSelected) {
      const product = this.productSelected.product_code as ProductsBiocatchEnum;
      if (product === ProductsBiocatchEnum.NOM) {
        this.bioCatchService.changeContext(
          StepBiocatchEnum.captura,
          product,
          false,
        );
      }
      this.product_code = this.productSelected.product_code;
      this.product_type = this.productSelected.product_type;
    } else {
      this.product_code = '';
      this.product_type = '';
    }
    const parms = {
      issusedIdentType: this.documentInfo.document_type,
      issusedIdentValue: this.documentInfo.document_number,
    };
    const nowDate = new Date();
    const { basic } = this.abreCuentasService.getCustomerData();
    const lastUpdateDate = new Date(basic.last_update_date);
    const configClient = this.parametersService.getSetting(
      OpEnum.CONFIG_CLIENT_EXIST,
    );
    lastUpdateDate.setDate(lastUpdateDate.getDate() + configClient.days_update);
    if (this.firmlyApprovedService.isEmpty() &&
      this.firmlyApprovedService.getOfferType_Channel() !== 'En_firme') {
      this.mandatoryUpdate = true;
    } else {
      this.mandatoryUpdate = false;
    }
    this.mandatoryUpdate = lastUpdateDate.getTime() < nowDate.getTime();
    console.warn(
      'VALIDACIÓN UPDATE-DATA >>>>>\n profession: ',
      basic.profession,
      this.occupationSelected,
      '\n lastUpdateDate: ',
      lastUpdateDate,
      '\n basic: ',
      basic,
      '\n ConfigClient: ',
      configClient,
    );
    if (basic.profession !== this.occupationSelected.name) {
      this.mandatoryUpdate = true;
    }
    if (!this.validationHelperService.isValidExistingClient()) {
      console.log(
        'Validaciones: ',
        this.validationHelperService.isValidExistingClient(),
      );
      this.mandatoryUpdate = true;
    }
    if (basic.marital_status === '' || basic.marital_status === undefined) {
      this.mandatoryUpdate = true;
    }
    this.is_loading_complete = true;
    if (this.mandatoryUpdate === true) {
      this.navigationService.pageLoadTag(false, ['pv432', '', 'pv86', '']);
    }
    if (this.taggingServices.isFirmlyAprovedMono()) {
      if (basic.profession !== this.occupationSelected.name) {
        this.sendUpdateDataChangeOccupationPageLoad();
      } else if (lastUpdateDate.getTime() < nowDate.getTime() || this.mandatoryUpdate) {
        this.sendOutdatePageLoad();
      } else {
        this.sendUpdateDataVolunteerPageLoad();
      }
    }
    // this.mandatoryUpdate === true ?
    // this.bitacoraService.saveDataInBitacora('client_update_data_mandatory')
    // : this.bitacoraService.saveDataInBitacora('client_update_data_optional');
    // if(this.mandatoryUpdate === false) {
    // this.navigationService.pageLoadTag(false, ['pv431', '', 'pv82', '']);
    // }
  }
  async callIncomes() {
    let strTypeProduct = this.abreCuentasService.getproductSelected().product_type;
    if (strTypeProduct === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
      await this.captureService
        .sendProspectOccupation()
        .then((res: any) => {
          let nextCode = '';
          if (res) {
            this.abreCuentasService.setinfoInferredIncomes(res.body.data);
            if (!res.status || res.status === 500) {
              nextCode = '500';
            } else if (res.status !== 200) {
              const codigo = res.body.data.codigo;
              switch (codigo) {
                case '422-06':
                  nextCode = '106';
                  break;
                case '422-07':
                  nextCode = '106';
                  break;
                case '400':
                  nextCode = '500';
                  break;
              }
            } else if (res.body.data.income_amount.amount === 0) {
              nextCode = '106';
            } else {
              nextCode = '000';
            }
          } else {
            nextCode = '500';
          }
          if (nextCode !== '' && nextCode !== '000') {
            this.navigationService.navigateToGeneralInformation(nextCode);
          }
        })
        .catch(() =>
          this.navigationService.navigateToGeneralInformation('500'),
        );
    }
  }
  pageTagEvent() {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E1setData`][
            `${tagPageName}E1transactionName`
          ].path,
          value:
            EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`]
              .value,
        },
        {
          path: EVENT[`${tagPageName}E1setData`][
            `${tagPageName}E1transactionDetailsProductcategory`
          ].path,
          value:
            EVENT[`${tagPageName}E1setData`][
              `${tagPageName}E1transactionDetailsProductcategory`
            ].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.bottom,
        },
        action: EVENT.customAction.click,
        label: '',
      };

      this.taggingServices.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * event next step
   */
  nextYes() {
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendYesButtonEvent();
    }
    this.abreCuentasService.setUpdateClient(true);
    this.pageTagEvent();
    this.navigationService.nextStep('201');
  }

  async nextNo() {
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendNoButtonEvent();
    }
    let strTypeProduct = this.abreCuentasService.getproductSelected().product_type;
    try {
      if (strTypeProduct === BUSINESS_CONST.MULTI || this.abreCuentasService.haveLoan) {
        await this.incomesService.callIncomes();
      }
    } catch (error) {
      this.handleError();
    }

    const housingList = this.parametersService.getSetting('housingType_list');
    this.livingResidence =
      this.abreCuentasService.getCustomerData().basic.housing_type;
    this.livingResidence = this.livingResidence
      ? this.helperService.validateDiacritialMask(this.livingResidence)
      : '';
    const contactInfo = this.abreCuentasService.getContactInfo();
    let modelInfo = {
      description: housingList.find(
        filter => filter.name === this.livingResidence,
      ).name,
      housingId: housingList.find(
        filter => filter.name === this.livingResidence,
      ).id,
    };
    contactInfo.address.housingType = modelInfo;
    this.pageTagEvent();
    this.validationHelperService.setCustomerDataClient();
    try {
      await this.captureService.createContactInfo();
      await this.captureService.prospectAddresses();
    } catch (e) {
      console.log(
        'Updtae-Data >>>>> Linea 187 >>>> Error consumiendo CaptureService >>>> ',
        e,
      );
      this.handleError();
    }
    this.abreCuentasService.setContactInfo(contactInfo);
    if (
      (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN ||
        this.product_type === BUSINESS_CONST.MULTI) &&
      this.firmlyApprovedService.isEmpty() &&
      this.firmlyApprovedService.getOfferType_Channel() !== 'En_firme'
    ) {
      await this.getPcoAmount();
      if (!this.pcoAmountValidation) {
        console.log(
          'Updtae-Data >>>>> Entró por False PCO AmountValidation >>>>> Linea 195 ',
        );
        return;
      }
    }
    try {
      await this.captureService.createFinancials();
      if (
        (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
        this.product_type === BUSINESS_CONST.MULTI)
        && !this.firmlyApprovedService.isFirmlyApproved()
      ) {
        await this.captureService.createClient();
      }
      this.advance();
    } catch (e) {
      console.log(
        'Updtae-Data >>>>> Linea 207 >>>> Error consumiendo >>>> ',
        e,
      );
      this.handleError();
    }
  }

  closeApp() {
    this.navigationService.loadExitScreen = true;
  }

  handleError() {
    this.navigationService.navigateToGeneralInformation('500');
  }

  clickTwoLink(event) {
    switch (event.item.content) {
      case 'Salir':
        this.navigationService.goToLoginPage();
        break;
      case 'Cancelar':
        break;
    }
    this.navigationService.loadExitScreen = false;
  }

  async getPcoAmount() {
    this.productLoaderService.show(this.copyService.copies.show_load_pco,
      this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
    this.bitacoraService.saveDataInBitacora('Ini_loading_PCO');
    await this.captureService.performPco().then(result => {
      if (result !== '200') {
        this.navigationService.navigateToGeneralInformation('127');
        return;
      }
    });
    await this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
    await this.captureService.getChannelComunicator(false, true).then(result2 => {
      this.pcoAmountValidation = true;
      if (result2 === '107' || result2 === '121' || result2 === '130' || result2 === '129' || result2 === '124' || result2 === '127') {
        // if (result2 === '129') {
        //   this.navigationService.pageLoadTag('ErrorProcesoEnTramite', ['pv426', '', 'pv572', '']);
        // }
        if (result2 === '121') {
          this.navigationService.pageLoadTag('ErrorSolicitudNoAprobada', ['pv438', '', '', '']);
        }
        this.navigationService.navigateToGeneralInformation(result2);
        this.pcoAmountValidation = false;
      }

      if (result2 === '17') {
        this.loanNormalization = true;
        this.navigationService.navigateToGeneralInformation(ERROR_LIB.CODE);
        this.bitacoraService.saveDataInBitacora('Normalization_yes');
      } else {
        this.bitacoraService.saveDataInBitacora('Out_loading_PCO');
        this.closeLoading = true;
      }
    }).catch(() => this.navigationService.navigateToGeneralInformation('107'));
  }

  async prospectAddresses() {
    this.captureService.prospectAddresses();
  }

  advance() {
    const bitacoraEvent = `client_no_update_data`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.abreCuentasService.hideGenericLoading();
    if (this.abreCuentasService.isGrayZone() && (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.product_type === BUSINESS_CONST.MULTI)) {
      this.navigationService.nextStep('202');
      this.checkLoading();
      return;
    }

    if (!this.loanNormalization) {
      this.navigationService.nextStep('200');
    }
    this.checkLoading();
  }

  checkLoading() {
    if (this.closeLoading) {
      this.productLoaderService.hide();
    }
  }

  isIndependentOrWorker(): boolean {
    return (
      this.occupationSelected.name === 'Empleado' ||
      this.occupationSelected.name === 'Independiente'
    );
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad - Actaulización de datos voluntaria ------------ */
  sendUpdateDataVolunteerPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv4pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv4pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv4pageFamily.path,
        value: PAGEVIEW_FA.pv4pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv4subFamily.path,
        value: PAGEVIEW_FA.pv4subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv4pageAction.path,
        value: PAGEVIEW_FA.pv4pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv4pageid.path,
        value: UpdateDataComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv4transactionName.path,
        value: `${PAGEVIEW_FA.pv4transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv4transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv4transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* ------------ Taggeo - PageLoad - Actaulización de obligatoria por datos desactualizados ------------ */
  sendOutdatePageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv5pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv5pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv5pageFamily.path,
        value: PAGEVIEW_FA.pv5pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv5subFamily.path,
        value: PAGEVIEW_FA.pv5subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv5pageAction.path,
        value: PAGEVIEW_FA.pv5pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv5pageid.path,
        value: UpdateDataComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv5transactionName.path,
        value: `${PAGEVIEW_FA.pv5transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv5transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv5transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* ------------ Taggeo - PageLoad - Actaulización de datos obligatoria por cambio de ocupación ------------ */
  sendUpdateDataChangeOccupationPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv6pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv6pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv6pageFamily.path,
        value: PAGEVIEW_FA.pv6pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv6subFamily.path,
        value: PAGEVIEW_FA.pv6subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv6pageAction.path,
        value: PAGEVIEW_FA.pv6pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv6pageid.path,
        value: UpdateDataComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv6transactionName.path,
        value: `${PAGEVIEW_FA.pv6transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv6transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv6transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */

  sendYesButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv5E1setData.pv5E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv5E1setData.pv5E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv5E1setData.pv5E1transactionName.path,
        value: `${EVENT_FA_LD.pv5E1setData.pv5E1transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv5E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendNoButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv5E2setData.pv5E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv5E2setData.pv5E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv5E2setData.pv5E2transactionName.path,
        value: `${EVENT_FA_LD.pv5E2setData.pv5E2transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv5E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }
}
